import React from 'react';
import googlePlayBadge from '../assets/images/google-play.png';
import windowsLogo from '../assets/images/windows-logo.png';
import macLogo from '../assets/images/macOS-logo.svg';

const DownloadSection = () => {
  const osOptions = [
    {
      id: 'windows',
      name: 'Windows',
      icon: (
        <img
          src={windowsLogo}
          alt="Windows 로고"
          style={{ height: 40, display: 'inline-block' }}
        />
      ),
      downloadUrl: 'https://1111-releases.cloudflareclient.com/win/latest',
      description: 'Windows 10/11 지원'
    },
    {
      id: 'macos',
      name: 'macOS',
      icon: (
        <img
          src={macLogo}
          alt="macOS 로고"
          style={{ height: 40, display: 'inline-block' }}
        />
      ),
      downloadUrl: 'https://1111-releases.cloudflareclient.com/mac/latest',
      description: 'macOS 10.15 이상'
    },
    {
      id: 'ios',
      name: 'iOS',
      icon: (
        <img
          src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
          alt="App Store에서 다운로드"
          style={{ height: 40, display: 'inline-block' }}
        />
      ),
      downloadUrl: 'https://apps.apple.com/us/app/cloudflare-one-agent/id6443476492',
      description: 'App Store에서 다운로드'
    },
    {
      id: 'android',
      name: 'Android',
      icon: (
        <img
          src={googlePlayBadge}
          alt="Google Play에서 다운로드"
          style={{ height: 40, display: 'inline-block' }}
        />
      ),
      downloadUrl: 'https://play.google.com/store/apps/details?id=com.cloudflare.cloudflareoneagent',
      description: 'Google Play에서 다운로드'
    }
  ];

  return (
    <section id="download" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            OS별 설치 파일 다운로드
          </h2>
          <p className="text-lg text-gray-600">
            사용하시는 운영체제에 맞는 WARP 클라이언트를 다운로드하세요.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {osOptions.map((os) => (
            <div
              key={os.id}
              className="p-6 rounded-lg border-2 border-gray-200 hover:border-gray-300 transition-all"
            >
              <div className="text-center">
                <div className="text-4xl mb-3">{os.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {os.name}
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  {os.description}
                </p>
                <button
                  className="w-full bg-shinsegae-blue text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
                  onClick={() => {
                    window.open(os.downloadUrl, '_blank');
                  }}
                >
                  다운로드
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
